import React from "react";
import { StyledDataGrid, DataTableDivContainer } from "./DataGridTable.style";
import { DataGridToolbar } from "../../ComponentsIndex";
// import GridRowApproveAction from "../GridRowAction/GridRowAction";

const DataGridTable = (props) => {
  const divContainerHeight = props.listWithTab ? "calc(100vh - 48px - 64px)" : "calc(100vh - 64px)";
  return (
    <DataTableDivContainer height={divContainerHeight}>
      {/* <Box sx={{ boxShadow: 2, width: "100%" }}> */}
      <StyledDataGrid
        rows={props.rows}
        columns={props.columns}
        pageSize={props.pageSize}
        rowsPerPageOptions={props.pageSizeOptions}
        onPageSizeChange={props.onPageSizeChange}
        totalRowCount={props.totalDevices}
        // checkboxSelection
        disableSelectionOnClick
        showColumnRightBorder={false}
        getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd")}
        disableColumnSelector={true}
        components={{
          Toolbar: DataGridToolbar,
        }}
        componentsProps={{
          toolbar: {
            header: props.toolbarHeader,
            filterPlaceholder: props.toolbarFilterPlaceholder,
            buttonConfigs: props.buttonConfigs ? props.buttonConfigs : [],
            showDateFilter: props.showDateFilter ? props.showDateFilter : false,
            onApplyDateFilter: props.onApplyDateFilter ? props.onApplyDateFilter : "",
            onClearFilter: props.onClearFilter ? props.onClearFilter : "",
            selectedFromDate: props.selectedFromDate ? props.selectedFromDate : "",
            selectedToDate: props.selectedToDate ? props.selectedToDate : "",
            paddingTop: props.paddingTop ? props.paddingTop : "20px",
          },
        }}
      />
      {/* </Box> */}
    </DataTableDivContainer>
  );
};

export default DataGridTable;
